module.exports = __webpack_public_path__ + "static/AvenirNextLTPro-BoldCn-2448468f24294be30b2de9995e348f82.woff2";